import type { CSSProperties } from 'react';
import { Textfit } from 'react-textfit';

import { useResizeObserver } from '@revelio/core';
import type { GetEntityDataV3Query } from '@revelio/data-access';
import { Divider, Text } from '@revelio/ui';

import styles from './company-summary.module.css';

type CompanySummaryProps = {
  data: GetEntityDataV3Query;
  isDragging?: boolean;
};

const TEXT_STYLES: CSSProperties = {
  height: 'calc(100% - 4px)',
  lineHeight: '1.2',
  fontWeight: 300,
  overflow: 'hidden',
};

export const CompanySummary = ({ data, isDragging }: CompanySummaryProps) => {
  const { containerRef, width, height } = useResizeObserver();

  const entity = data.entityV3?.entity;
  const description = entity?.description;
  const founded = entity?.founded;
  const headquarters = entity?.headquarters;

  return (
    <div className={styles.layout}>
      <div className={styles.description} ref={containerRef}>
        {isDragging || !(width && height) ? (
          <Text className={styles.descriptionText}>{description}</Text>
        ) : (
          <Textfit mode="multi" min={10} max={200} style={TEXT_STYLES}>
            <Text fontSize="inherit">{description}</Text>
          </Textfit>
        )}
      </div>

      <div className={styles.facts}>
        <Divider className={styles.factsDivider} />
        <div className={styles.factsRow}>
          <div className={styles.foundedFact}>
            <Text fontSize="sm" weight="semibold" className={styles.factLabel}>
              Founded:
            </Text>
            <Text fontSize="sm">{founded}</Text>
          </div>
          <Text fontSize="sm" weight="semibold" className={styles.factLabel}>
            Headquarters:
          </Text>
          <Text
            fontSize="sm"
            className={styles.factValueTruncated}
            title={headquarters || ''}
          >
            {headquarters}
          </Text>
        </div>
      </div>
    </div>
  );
};
